
import config from '../app-config';

const StartImbyTool = (props) => {
    return (
        <div className={props.classNames}>
            <div className="well well-warning">
                <div className="row justify-content-center">
                    <h4>Denk mee!</h4>
                </div>
                <div className="row justify-content-center">
                    <a type="button" className="btn btn-dark" href={config.imbyUrl}>Start nu</a>
                </div>
            </div>
        </div>
    );
}

export default StartImbyTool;